const getTimeRemaining = (targetTimestamp: number = 0, additionalOffset: number, timeUnit: number) => {
  if (!targetTimestamp) {
    return 0;
  }

  const timeLeft = Math.round((targetTimestamp + additionalOffset - new Date().getTime()) / timeUnit);

  return timeLeft > 0 ? timeLeft : 0;
};

export default getTimeRemaining;
